<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">

        <b-button block v-b-toggle.term-section-2
        class="text-left fw-500 d-flex align-items-center justify-content-between">
            <div>
                <span class="box-numbering">02</span>
                <span>Eligibility To use {{ companyName }}</span>    
            </div>
            <span 
                class="toggle-icon" 
                :class="{ active: isOpen }"
            >
                <span class="plus">+</span>
                <span class="cross">×</span>
            </span> 
        </b-button>


      </b-card-header>
      <b-collapse
        id="term-section-2"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            Eligibility To use {{ companyName }} card solutions, you must:
            <ol>
                <li>Be at least 18 years old or the legal age of majority in your jurisdiction.</li>
                <li>Provide accurate and complete information during registration and maintain its accuracy.</li>
                <li>Agree to comply with all applicable laws and regulations.</li>
            </ol>  
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "term-2",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
